import { render } from "./HarvesterHugepages.vue?vue&type=template&id=f5267f88"
import script from "./HarvesterHugepages.vue?vue&type=script&lang=js"
export * from "./HarvesterHugepages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__